import { useContext } from "react"
import Header from "../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Typography } from "@mui/material"
import BackIcon from "../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import CustomConditionalActionsTableServer from "../../components/CustomConditionalActionsTableServerSide"
import { GlobalContext } from "../../contexts/GlobalContext"
import { api } from "../../api"
import getIconComponent from "../utils/getIconComponent"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(4), // Ajustado para que no choque con el Header
  flexGrow: 1,
  padding: "0 16px",
}))

const theme = createTheme({
  palette: {
    primary: { main: "#196C87" },
    secondary: { main: "#196C87" },
  },
})

const AltasPPE = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
          <Typography variant="h5" fontWeight="bold">
            Historial de Altas de Activos (PPE)
          </Typography>
        </Box>

        <Box className={StyledRoot}>
          <CustomConditionalActionsTableServer
            endpoint="/AltasPPE/getAllAltasPPE" // Endpoint que actualizamos a POST[cite: 1]
            errorMsgFilterSearch="Error al cargar el historial de Altas"
            queryKeyModal="AltasPPE"
            perPage={10}
            rowActionsWidthTable={100}
            rowActions={(row) => {
              const consultarAction = selectedMenuInfo?.data?.barraAcciones?.find(
                (action) => action?.acccaption === "CONSULTAR",
              )

              // Acciones dinámicas basadas en permisos
              return [
                {
                  label: consultarAction?.acccaption || "Consultar",
                  key: "consultar",
                  icon: getIconComponent(consultarAction?.accnameicono || "EyeIcon", consultarAction?.acctipoico),
                  onClick: (row) => {
                    navigate("consultar", { state: row.original })
                  },
                },
              ]
            }}
            topToolbarCustomActions={({ table, device }) => {
              const crearAction = selectedMenuInfo?.data?.barraAcciones?.find((action) => action.acccaption === "CREAR")

              return [
                {
                  label: crearAction?.acccaption || "Crear Alta",
                  key: "crearAlta",
                  icon: getIconComponent(crearAction?.accnameicono || "PlusIcon", crearAction?.acctipoico),
                  onClick: () => {
                    navigate("crear")
                  },
                },
              ]
            }}
            // Definición de columnas usando los alias del backend
            columnsTable={[
              {
                accessorKey: "comprobante",
                header: "Comprobante",
                size: 150,
              },
              {
                accessorKey: "fecha",
                header: "Fecha",
                size: 120,
              },
              {
                accessorKey: "proveedor",
                header: "Proveedor",
                size: 250,
              },
              {
                accessorKey: "factura",
                header: "Factura",
                size: 150,
              },
              {
                accessorKey: "total",
                header: "Total ($)",
                size: 120,
                Cell: ({ cell }) => {
                  const val = cell.getValue()
                  return <span>${Number(val || 0).toFixed(2)}</span>
                },
              },
              {
                accessorKey: "observacion",
                header: "Detalle / Observación",
                size: 300,
              },
              {
                accessorKey: "estado_label",
                header: "Estado",
                size: 120,
                Cell: ({ cell }) => {
                  const valor = cell.getValue()
                  return (
                    <span
                      style={{
                        color: valor === "ACTIVO" ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {valor}
                    </span>
                  )
                },
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default AltasPPE
